/* @flow */

// (acc -> { key: String, value: any } -> acc) -> acc -> Object any -> acc
export const objectReduce = (f: (any, Object) => any): any => (initial: Object | boolean): any => (o: Object): any =>
  Object.keys(o).reduce((result, key) => f(result, { key: key, value: o[key] }), initial)

// (any -> Bool) -> Object any -> Bool
export const objectAll = (func: (any) => boolean): boolean => objectReduce((acc, { value }) => acc && func(value))(true)

// (any -> Bool) -> Object any -> Bool
export const objectSome = (func: (any) => (boolean) => any): boolean =>
  objectReduce((acc, { value }) => acc || func(value))(false)

// func(value, key)
export const objectMap = (func: (Object, string) => Object, obj: Object): Object => {
  return Object.keys(obj).reduce((result, key) => {
    result[key] = func(obj[key], key)
    return result
  }, {})
}

export const prefixKeys = (pre: string, obj: Object): Object => {
  return Object.keys(obj).reduce((result, key) => {
    result[`${pre}_${key}`] = obj[key]
    return result
  }, {})
}

export const toFormData = (obj: Object, form: FormData, namespace: ?string) => {
  const fd: FormData = form || new FormData()
  let formKey: ?string

  for (let property: string in obj) {
    if (obj.hasOwnProperty(property) && obj[property]) {
      if (namespace) {
        formKey = namespace + '[' + property + ']'
      } else {
        formKey = property
      }

      // if the property is an object, but not a File, use recursivity.
      if (obj[property] instanceof Date) {
        fd.append(formKey, obj[property].toISOString())
      } else if (typeof obj[property] === 'object' && !(obj[property] instanceof File)) {
        toFormData(obj[property], fd, formKey)
      } else {
        // if it's a string or a File object
        fd.append(formKey, obj[property])
      }
    }
  }

  return fd
}
